/// <reference path="../../app.ts" />

namespace Cfnc {
    "use strict";

    interface IPublicPrivateModalScope extends ng.IScope {
        vm: IPublicPrivateModal;
    }

    interface IPublicPrivateModal {
        selectedFilters: Array<any>;
        religiousFilters: IAvaliableFiltersGroup;
        religions1: Array<any>;
        religions2: Array<any>;
        PrivateReligiousChecked: boolean;
        cancel: () => void;
        ok: () => void;
    }

    class PublicPrivateModalCtrl implements IPublicPrivateModal {
        static controllerId: string = "publicPrivateModalCtrl";
        static $inject: Array<string> = ["common", "$scope", "$uibModalInstance", "selectedFilters", "religions"];
        private log;
        selectedFilters: Array<any>;
        religiousFilters: IAvaliableFiltersGroup;
        religions1: Array<any>;
        religions2: Array<any>;
        PrivateReligiousChecked: boolean;

        constructor(private common: ICommonFactory, private $scope: IPublicPrivateModalScope, private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, selectedFilters: IAvaliableFiltersGroup[], religions: IAvaliableFiltersGroup) {

            var cutOff: number;

            this.log = common.logger.getLogFn(PublicPrivateModalCtrl.controllerId);
            this.activate();
            this.selectedFilters = selectedFilters;
            this.religiousFilters = religions;

            cutOff = (religions.filters.length / 2) + 1;
            this.religions1 = religions.filters.slice(0, cutOff);
            this.religions2 = religions.filters.slice(cutOff);
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, PublicPrivateModalCtrl.controllerId).then(() => {
                this.log("Activated Modal");
            });
        }

        cancel() {
            //this.privateNonRelgiousSelected();
            this.$uibModalInstance.dismiss('cancel');
        }

        ok() {
            //this.privateNonRelgiousSelected();
            this.$uibModalInstance.close(this.selectedFilters);
        }

        privateNonRelgiousSelected = () => {
            var hasPrivateSelected = _.some(this.selectedFilters, (group: IAvaliableFiltersGroup) => {
                return group.key == "PublicPrivate" && _.some(group.filters, (f: IAvailableFilterOption) => { return f.key == "Private"})
            });
            if (hasPrivateSelected)
            {
                var group: IAvaliableFiltersGroup = _.find(this.selectedFilters, (g: IAvaliableFiltersGroup) => { return g.key == "Religions" })

                if (group) {
                    group.filters.push({
                        pillText: "",
                        displayName: "",
                        key: "NullReligion"
                    })
                }
            }
        };
    }

    angular.module("app").controller(PublicPrivateModalCtrl.controllerId, PublicPrivateModalCtrl);
}